import { useQuery } from 'react-query';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import useInjection from 'hooks/useInjection';

export const useSalesPlansAnalytics = () => {
  const userProfileService = useInjection(
    SERVICE_IDENTIFIER.UserProfileService,
  );

  return useQuery({
    queryKey: ['user_analytics'],
    queryFn: () => userProfileService.getUserAnalytics(),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
